<div class="modal-overlay" (click)="closeModal()"></div>
<div class="modal-container {{size}}">
  <div class="modal-content">
    <ng-content></ng-content>
  </div>
</div>